import PropTypes from 'prop-types';
import styled from 'styled-components';
import colors from './constants/colors';

const HelperText = styled.div`
  color: ${colors.tulleGrey};
  font-size: 14px;
  transition: all 0.125s ease-out;
  padding: 2px 0;
`;

export default HelperText;

HelperText.propsTypes = {
  errorMessage: PropTypes.string,
};

HelperText.defaultProps = {
  errorMessage: undefined,
};
